import {Grid, TextField, Typography} from '@mui/material';
import FormikSwitch from 'components/inputs/FormikSwitch';
import FormikTextField from 'components/inputs/FormikTextField';
import Panel from 'components/Panel';
import React from 'react';
import {ISftpServerSettings, SftpServerSettingsNames} from 'types/diplomat/sftp/SftpServerSettings';
import {EdgeGatewayStatusIcon} from 'features/layout/CommonPage/panels/SFTP/SFTPServerSettingsPanel/EdgeGatewayStatusIcon';
import {useFieldValueGetter} from 'components/hook-form/useFieldValueGetter';
import {useTranslation} from 'react-i18next';
import {IEdgeGatewayStatus} from 'types/StatesResponse';
import {layoutSelectors} from 'features/layout/redux';
import {useSelector} from 'react-redux';
import {Box} from '@mui/system';

const ProxyPanel = ({connectorId}: {connectorId: string}) => {
   const {t} = useTranslation();
   const edgeGatewayStatus = useSelector(layoutSelectors.getEdgeGatewayStatuses);

   const status = edgeGatewayStatus?.find((s: IEdgeGatewayStatus) => s[connectorId]);
   const data = status?.[connectorId];

   return (
      <>
         <Grid item xs={8}>
            <TextField
               //    name={EdgeGatewayStatusNames.dataPort}
               value={data?.dataPort}
               label={t('Data Port')}
               disabled
            />
         </Grid>
         <Grid item xs={12}>
            <Box
               width="1.5rem"
               height="1.5rem"
               borderRadius="50%"
               style={{
                  backgroundColor: data?.isProxyEnabled ? 'green' : 'red',
                  display: 'inline-block',
                  marginRight: '.5rem',
                  verticalAlign: 'middle',
               }}
               component="div"
            />
            <Typography component="span">
               {t('Proxy Server {{status}}', {
                  status: data?.isProxyEnabled ? t('Enabled') : t('Disabled'),
               })}
            </Typography>
         </Grid>
         <Grid item xs={8}>
            <TextField
               //    name={EdgeGatewayStatusNames.proxyPort}
               value={data?.proxyPort}
               label={t('Proxy Port')}
               disabled
            />
         </Grid>
      </>
   );
};

const margin = '3.2rem';
export const EdgeGatewayPanel = () => {
   const {t} = useTranslation();
   const getValue = useFieldValueGetter<ISftpServerSettings>();

   const useGateway = getValue('useGateway');
   const connectorId = getValue(SftpServerSettingsNames.gconnID);

   return (
      <Panel name={t('Edge Gateway Settings')} style={{height: '32rem', marginTop: '3rem'}}>
         <Grid container spacing={3}>
            <Grid item>
               <EdgeGatewayStatusIcon connectorId={connectorId} />
            </Grid>
            <Grid item xs={10}>
               <FormikSwitch
                  label={t('Edge Gateway ({{status}})', {
                     status: useGateway ? t('Enabled') : t('Disabled'),
                  })}
                  // labels={[t('Enable'), t('Disable')]}
                  name={SftpServerSettingsNames.useGateway}
               />
            </Grid>
            <Grid item xs={6} container sx={{marginBottom: margin}}>
               <Grid item xs={12}>
                  <FormikTextField
                     name={SftpServerSettingsNames.edgeIP}
                     label={t('Edge Gateway Address')}
                  />
               </Grid>
               <Grid item xs={8}>
                  <FormikTextField name={SftpServerSettingsNames.pncPort} label={t('Port')} />
               </Grid>
               <Grid item xs={12}>
                  <FormikTextField
                     name={SftpServerSettingsNames.gconnID}
                     label={t('Connection Identifier')}
                  />
               </Grid>
            </Grid>

            <Grid item xs={6} container spacing={1} sx={{marginTop: margin}}>
               <ProxyPanel connectorId={connectorId} />
            </Grid>

            {/* <Grid item xs={10} container spacing={0}>
               <Grid item xs={12}>
                  <FormikSwitch
                     label={t('Allow SFTP through Edge Gateway')}
                     // labels={[t('Enable'), t('Disable')]}
                     name={SftpServerSettingsNames.allowSftpThroughEG}
                  />
               </Grid>
               <Grid item xs={12}>
                  <FormikSwitch
                     label={t('Allow Web Transfer through Edge Gateway')}
                     // labels={[t('Enable'), t('Disable')]}
                     name={SftpServerSettingsNames.allowWebTransferThroughEG}
                  />
               </Grid>
            </Grid> */}
         </Grid>
      </Panel>
   );
};
